export const handleApiError = (
  err,
  { setErrors, silent = false, showToast, fieldMap = {} } = {},
) => {
  // ⚪ IGNORE THUNK CONDITION / STALE ABORTS
  if (
    err?.name === "ConditionError" ||
    err === "stale_skip" ||
    (typeof err?.message === "string" &&
      err.message.includes("condition callback"))
  ) {
    return;
  }

  // 🟡 STRING ERROR (like "Invalid credentials")
  if (typeof err === "string") {
    if (!silent && showToast) {
      showToast(err, "danger");
    }
    return;
  }

  const validationErrors = err?.data?.data || err?.errors || err?.data;

  // 🟢 Validation errors
  if (
    validationErrors &&
    typeof validationErrors === "object" &&
    !Array.isArray(validationErrors)
  ) {
    const formikErrors = {};

    Object.keys(validationErrors).forEach((field) => {
      const mappedField = fieldMap[field] || field;
      formikErrors[mappedField] = validationErrors[field][0];
    });

    if (setErrors) {
      setErrors(formikErrors);
    }

    if (!silent && showToast) {
      showToast(err?.message || "Validation Error", "danger");
    }
    return;
  }

  // 🔴 Generic error
  if (!silent && showToast) {
    showToast(err?.data?.message || err?.message || err?.error || "Something went wrong", "danger");
  }

  if (setErrors && err?.data && typeof err.data === "object") {
    setErrors(err.data);
  }
};
